import Cookies from 'js-cookie'

const state = {
  sidebar: {
    opened: Cookies.get('sidebarStatus') ? !!+Cookies.get('sidebarStatus') : true,
    withoutAnimation: false
  },
  device: 'desktop',
  size: localStorage.getItem('layout-size') || 'medium',
  pageSizes: [10, 15, 20, 30, 50],
  ouType: '22',
  auType: '22',
  dsType: '22',
}

const mutations = {
  TOGGLE_SIDEBAR: state => {
    state.sidebar.opened = !state.sidebar.opened
    state.sidebar.withoutAnimation = false
    if (state.sidebar.opened) {
      Cookies.set('sidebarStatus', 1)
    } else {
      Cookies.set('sidebarStatus', 0)
    }
  },
  CLOSE_SIDEBAR: (state, withoutAnimation) => {
    Cookies.set('sidebarStatus', 0)
    state.sidebar.opened = false
    state.sidebar.withoutAnimation = withoutAnimation
  },
  TOGGLE_DEVICE: (state, device) => {
    state.device = device
  },
  SET_SIZE: (state, size) => {
    state.size = size
    localStorage.setItem("layout-size", size);
  },
  SET_OU_TYPE: (state, ouType) => {
    state.ouType = ouType;
  },
  SET_AU_TYPE: (state, auType) => {
    state.auType = auType;
  },
  SET_DS_TYPE: (state, dsType) => {
    state.dsType = dsType;
  },
}

const actions = {
  toggleSideBar({ commit }) {
    commit('TOGGLE_SIDEBAR')
  },
  closeSideBar({ commit }, { withoutAnimation }) {
    commit('CLOSE_SIDEBAR', withoutAnimation)
  },
  toggleDevice({ commit }, device) {
    commit('TOGGLE_DEVICE', device)
  },
  setSize({ commit }, size) {
    commit('SET_SIZE', size)
  },
  setOuSize({ commit }, ouType) {
    commit('SET_OU_TYPE', ouType)
  },
  setAuSize({ commit }, auType) {
    commit('SET_AU_TYPE', auType)
  },
  setDsSize({ commit }, dsType) {
    commit('SET_DS_TYPE', dsType)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/app.js